import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

export default function Member_Details() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [allMember, setAllMember] = useState("");
  const [fromRegdate, setfromRegdate] = useState("");
  const [toRegdate, settoRegdate] = useState("");
  const [PlanId, setPlanId] = useState(0);
  const [topupStatus, settopupStatus] = useState("");
  const [checkblockStatus, setcheckblockStatus] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search,
          fromdate: fromDate,
          todate: toDate,
          // Regfromdate: fromRegdate,
          Blockstatus: checkblockStatus,
          topup: topupStatus,
          PlanId: PlanId,
          PageIndex: "1",
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("memberlist-->", responceRight.data.data);
      // setStakingdata(responceRight?.data?.data.records[0])
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          // id: `${item?.uid} `,
          login: (
            <>
              <a
                href={`https://olamworld.biz/AdminLogin?user_id=${item.uid}&enpass=${item?.password}`}
                target="_blank"
                className="btn btn-lg btn-primary"
              >
                Login
              </a>
            </>
          ),
          user_id: `${item?.uid} `,
          sid: `${item?.sid} `,
          Waddress: `${item?.f_name} `,
          lipa: item?.ipaddress,
          RegDate: `${item?.date}`,
          PlanType: item?.PlanType,
          package: `${item?.packageamount}`,
          top_update1: item?.top_update1,
          edate: `${item?.edate} `,
          Topupstatus:
            item?.top_up === 1 ? (
              <span className="text-success">Active</span>
            ) : (
              <span className="text-danger">InActive</span>
            ),
          status:
            item?.blockstatus === "Block" ? (
              <span className="text-danger">{item?.blockstatus}</span>
            ) : (
              <span className="text-success">{item?.blockstatus}</span>
            ),
          top_up_Stack: `${item?.top_Stack === 1 ? "Active" : "InActive"}`,
          top_up: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          top_update_Stack: item?.top_update_Stack,
          top_update: item?.top_update,
          staking: (
            <>
              <button
                className={`${
                  item?.blockstatus === "Active" ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() => Status_active(item?.uid, item?.blockstatus, 1)}
              >
                {item?.blockstatus === "Active" ? "Block" : "Active"}
              </button>
            </>
          ),
          WithStatus: `${item?.WithdrawalStatus == 1 ? "Active" : "Block"}`,
          withAction: (
            <>
              <button
                className={`${
                  item?.WithdrawalStatus === 1 ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() =>
                  Status_active_withdraw(item?.uid, item?.WithdrawalStatus, 1)
                }
              >
                {item?.WithdrawalStatus === 1 ? "Block" : "Active"}
              </button>
            </>
          ),
          ComStatus: `${item?.CommunityStatus == 1 ? "Active" : "Block"}`,
          ComAction: (
            <>
              <button
                className={`${
                  item?.CommunityStatus === 1 ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() =>
                  Status_active_Community(item?.uid, item?.CommunityStatus, 1)
                }
              >
                {item?.CommunityStatus === 1 ? "Block" : "Active"}
              </button>
            </>
          ),
          edit: (
            <>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() =>
                  navigate(`/Edit_Details?userId=${item?.user_id}`)
                }
              >
                Edit
              </button>
            </>
          ),
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const Status_active = async (id, blockstatus) => {
    try {
      console.log("statevalue", blockstatus);
      let status_value = blockstatus;
      let status = 1;

      if (status_value == "Active") {
        status = 0;
      } else {
        status = 1;
      }
      // console.log("id=>", id);
      // console.log("status=>", status);
      let res = await API?.post(
        "/Changestatus",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Status_active_withdraw = async (id, withdrawl_status, type) => {
    try {
      let status = 1;

      if (withdrawl_status == 1) {
        status = 0;
      } else {
        status = 1;
      }

      let res = await API?.post(
        "/ChangeWtihdrawalStatus",
        {
          loginid: userId,
          uid: id,
          status: status,
          type: type,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Status Changed Successfully...");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Status_active_Community = async (id, Community_status, type) => {
    try {
      let status = 1;

      if (Community_status == 1) {
        status = 0;
      } else {
        status = 1;
      }

      let res = await API?.post(
        "/ChangeCommunityStatus",
        {
          loginid: userId,
          uid: id,
          status: status,
          type: type,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Status Changed Successfully...");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search,
          fromdate: fromDate,
          todate: toDate,
          // Regfromdate: fromRegdate,
          Blockstatus: checkblockStatus,
          topup: topupStatus,
          PlanId: PlanId,
          PageIndex: "1",
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("memberlist-->", responceRight.data.data);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: `${item?.uid} `,
          SponsorId: `${item?.sid} `,
          Wallet_Address: `${item?.password} `,
          // IP_Address: `${item?.ipaddress} `,
          RegDate: `${item?.date}`,
          Package: `${item?.packageamount}`,
          ActDate: item?.top_update1,
          Status: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          BlockStatus: item?.blockstatus,
        });
      });

      const fileName = "AllmembersRecord";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Login", accessor: "login" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Name", accessor: "Waddress" },
      { Header: "Sponsor Id", accessor: "sid" },

      // { Header: "Login IP Address", accessor: "lipa" },
      { Header: "Reg. Date", accessor: "RegDate" },
      { Header: "ID Type", accessor: "Topupstatus" },
      { Header: "Activation  Amount", accessor: "package" },
      { Header: "Activation  Date", accessor: "top_update1" },
      { Header: "Block Status", accessor: "status" },
      { Header: "Action", accessor: "staking" },
      // { Header: "Withdrawl Status", accessor: "Withstatus" },
      // { Header: "Withdrawl Action", accessor: "withstaking" },
      { Header: "With. Status", accessor: "WithStatus" },
      { Header: "With. Action", accessor: "withAction" },
      // { Header: "Comm. Status", accessor: "ComStatus" },
      // { Header: "Comm. Action", accessor: "ComAction" },
      { Header: "Edit", accessor: "edit" },
    ],
  });

  // if (isLoading) return <Spinner />;

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Member Details</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <label>User Id</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        id="uid"
                        onChange={(e) => setSearch(e.target.value)}
                        name="uid"
                        placeholder="Search By User Id or Name or Email"
                        type="text"
                        value={search}
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Status</label>
                      <br />
                      <select
                        name="Position"
                        class="form-control in-ip-1"
                        onChange={(e) => settopupStatus(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label>Block Status</label>
                      <br />
                      <select
                        name="Position"
                        class="form-control in-ip-1"
                        onChange={(e) => setcheckblockStatus(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="1">Block</option>
                        <option value="0">Active</option>
                      </select>
                    </div>
                    <div class="col-md-2 text-center">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2 text-center">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                    <div class="col-md-3 text-center">
                      <br />
                      <button
                        className="btn btn-primary"
                        onClick={() => Status_active_withdraw(0, 0, 2)}
                      >
                        All Withdrawal Start
                      </button>
                    </div>
                    <div class="col-md-3 text-center">
                      <br />
                      <button
                        className="btn btn-danger"
                        onClick={() => Status_active_withdraw(0, 1, 2)}
                      >
                        All Withdrawal Stop
                      </button>
                    </div>
                    {/* <div class="col-md-3 text-center">
                      <br />
                      <button
                        className="btn btn-primary"
                        onClick={() => Status_active_Community(0, 0, 2)}
                      >
                        All Community Start
                      </button>
                    </div>
                    <div class="col-md-3 text-center">
                      <br />
                      <button
                        className="btn btn-danger"
                        onClick={() => Status_active_Community(0, 1, 2)}
                      >
                        All Community Stop
                      </button>
                    </div> */}
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div>
                        <div className="col-md-12">
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
